module.exports = __webpack_public_path__ + "static/media/ic-message-empty.ea2500b9.svg";